var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPTflag = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.301697 11.292C0.301697 15.8019 3.14817 19.6466 7.14233 21.1286L8.05447 11.2919L7.14233 1.45532C3.14817 2.93739 0.301697 6.78205 0.301697 11.292Z",
    fill: "#6DA544"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.28 11.2918C21.28 5.49889 16.5838 0.802734 10.7909 0.802734C9.50786 0.802734 8.2788 1.03353 7.14246 1.45515V21.1285C8.2788 21.5501 9.50786 21.7809 10.7909 21.7809C16.5838 21.7809 21.28 17.0847 21.28 11.2918Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14237 14.939C9.1573 14.939 10.7907 13.3056 10.7907 11.2907C10.7907 9.27576 9.1573 7.64233 7.14237 7.64233C5.12744 7.64233 3.49402 9.27576 3.49402 11.2907C3.49402 13.3056 5.12744 14.939 7.14237 14.939Z",
    fill: "#FFDA44"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPTflag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/PTflag.00b9bd10.svg";
export { ForwardRef as ReactComponent };